import { render, staticRenderFns } from "./TaxesIndex.vue?vue&type=template&id=6765ed55"
import script from "./TaxesIndex.vue?vue&type=script&lang=js"
export * from "./TaxesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports